










































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { axiosM, axiosC, resHandle } from "@/plugins/axios";
import Copy from "@/components/copy.vue";
import SimplePagination from "@/components/simple_pagination.vue";
import ConfirmDialog from "@/components/dialogs/confirmDialog.vue";
import MainHeader from "../../../main/components/main-header/main-header.vue";
// import LeftNav from "../../components/project-list-left-nav.vue";
import LeftNav from "../../../sjzx/modules/zbsjk/components/nav-left.vue";
@Component({
  components: {
    MainHeader,
    Copy,
    LeftNav,
    ConfirmDialog,
    SimplePagination,
  },
})
export default class ProjectList extends Vue {
  private projectState: any = "";
  private projects: any[] = [];
  private currentPage: any = 1;
  private totalPage: any = 0;
  private totalCount: any = 0;
  // 确认弹窗
  private cProject: any = {};
  private confirmState: "lock" | "open" | "clear" | "delete" = "lock";
  private confirmVisible: boolean = false;
  private confirmTitle: any = "温馨提示";
  private confirmHelp: any =
    "锁定数据后将无法对项目进行编辑和数据录入，确定锁定吗？";
  private get windowWidth() {
    return window.innerWidth;
  }
  /**
   * @description 获取项目列表
   */
  private fetch() {
    const params: any = {
      params: {
        状态: this.projectState,
        current_page: this.currentPage,
        page_count: 6,
      },
    };
    axios.get("api/project/list", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.projects = data.data.projects;
        this.totalPage = data.data.total_page;
        this.totalCount = data.data.total_count;
      });
    });
  }
  /**
   * @description 上一页
   */
  private prev() {
    if (this.currentPage === 1) {
      return;
    } else {
      this.currentPage--;
      this.fetch();
    }
  }
  /**
   * @description 下一页
   */
  private next() {
    if (this.currentPage >= this.totalPage) {
      return;
    } else {
      this.currentPage++;
      this.fetch();
    }
  }
  /**
   * @description 跳转创建项目
   */
  private jumpProjectCreateFirst() {
    this.$router.push("/main/project/project-create-first");
  }
  /**
   * @description 打开是否确定锁定项目弹窗
   */
  private openIfLockConfirm(project) {
    this.confirmState = "lock";
    this.confirmTitle = "温馨提示";
    this.confirmHelp = "锁定数据后将无法对项目进行编辑和数据录入，确定锁定吗？";
    this.confirmVisible = true;
    this.cProject = project;
  }
  /**
   * @description 打开是否确定开放项目弹窗
   */
  private openIfOpenConfirm(project) {
    this.confirmState = "open";
    this.confirmTitle = "温馨提示";
    this.confirmHelp =
      "开放数据后对项目可以进行正常编辑和数据录入，确定开放吗？";
    this.confirmVisible = true;
    this.cProject = project;
  }
  /**
   * @description 锁定项目
   */
  private lockProject() {
    const params: any = {
      project_id: this.cProject.project_id,
      action: "锁定",
    };
    axios.post("api/project/status", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.confirmVisible = false;
        this.fetch();
      });
    });
  }
  /**
   * @description 开放项目
   */
  private openProject() {
    const params: any = {
      project_id: this.cProject.project_id,
      action: "进行",
    };
    axios.post("api/project/status", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.confirmVisible = false;
        this.fetch();
      });
    });
  }
  /**
   * @description 打开是否确定清空项目数据弹窗
   */
  private openIfClearConfirm(project) {
    this.confirmState = "clear";
    this.confirmTitle = "温馨提示";
    this.confirmHelp = "您确定清空所有患者的队列数据吗？";
    this.confirmVisible = true;
    this.cProject = project;
  }
  /**
   * @description 清空某项目下的所有数据
   */
  private clearProjectData() {
    const params: any = {
      project_id: this.cProject.project_id,
    };
    axios.post("api/project/deldata", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.$message.success("清空成功");
        this.confirmVisible = false;
        this.fetch();
      });
    });
  }
  /**
   * @description 打开是否确定清空项目数据弹窗
   */
  private openIfDeleteConfirm(project) {
    this.confirmState = "delete";
    this.confirmTitle = "温馨提示";
    this.confirmHelp = "您确定删除该项目的所有信息吗？";
    this.confirmVisible = true;
    this.cProject = project;
  }
  /**
   * @description 删除某个项目
   */
  private deleteProject() {
    const params: any = {
      data: {
        project_id: this.cProject.project_id,
      },
    };
    axios.delete("api/project", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.$message.success("删除成功");
        this.confirmVisible = false;
        this.fetch();
      });
    });
  }
  /**
   * @description 处理点击项目拓展功能
   */
  private clickProject(command, project) {
    switch (command) {
      case "锁定数据":
        this.openIfLockConfirm(project);
        break;
      case "开放数据":
        this.openIfOpenConfirm(project);
        break;
      case "清空数据":
        this.openIfClearConfirm(project);
        break;
      case "删除":
        this.openIfDeleteConfirm(project);
        break;
    }
  }
  /**
   * @description 处理弹窗取消
   */
  private handleCancel() {
    this.confirmVisible = false;
  }
  /**
   * @description 处理弹窗确定
   */
  private handleConfirm() {
    switch (this.confirmState) {
      case "lock":
        this.lockProject();
        break;
      case "open":
        this.openProject();
        break;
      case "clear":
        this.clearProjectData();
        break;
      case "delete":
        this.deleteProject();
        break;
    }
  }
  /**
   * @description 跳转研究队列
   */
  private jumpResearchList(project) {
    this.$router.push(
      "/main/project/research-list-folder/" + project.project_id
    );
  }
  /**
   * @description 初始化
   */
  private beforeMount() {
    this.fetch();
  }
}
